angular.module('octopusApp.tenants')
    .directive('filterTagsByTagset', function() {
    return{
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr, ngModel){
            var rootValue = [];
            var tagSetName = attr["filterTagsByTagset"];
            var tagsInThisTagSet = scope.vm[attr["filterTagsByTagsetAll"]]
                .filter(function(a){ return a.Name === tagSetName; })[0]
                .Tags.map(function(a){ return a.CanonicalTagName; });

            ngModel.$formatters.push(function(value) {
                rootValue = value || [];
                return tagsInThisTagSet
                    .filter(function(a) { return rootValue.indexOf(a) !== -1; });
            });

            ngModel.$parsers.push(function(value){
                return _.difference(rootValue, tagsInThisTagSet).concat(value);
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/advanced_tenant_selector/filter_tags_by_tagset.js
// module id = 806427995883430
// module chunks = 1